import { ref, onMounted } from '@vue/composition-api'
import { getRecommendations } from './recommendations.usecase'
import {useStore} from '../../core/hooks'
import {CATEGORY_KEYWORDS} from '../../components/AdvancedSearch/categories'

const useRecommendations = () => {
    const campaigns = ref([])

    const {state} = useStore()

    onMounted(() => {

        if(!state.value.publishedCampaignIds.length) {
            return
        }

        const filteredCampaigns = state.value.publishedCampaignIds
            .filter(camp => {
                const requiredConditions = camp.state !== 'ended' && !camp.hidden

                if(state.value.user.subscription) {
                    return requiredConditions && camp.created_at.seconds < state.value.user.subscription.endDate.seconds
                }

                if(state.value.user.trial) {
                    return requiredConditions && camp.created_at.seconds < state.value.user.trial.endDate.seconds
                }

                return requiredConditions
            })

        if(!filteredCampaigns.length) return
        
        const searchParams = filteredCampaigns
            .map(item => {
                return {
                    tags: item.tags,
                    category: item.category,
                    backers: item.backers
                }
            })
            .reduce((accum, currentValue) => {
                if(accum) {
                    if(currentValue.tags) {
                        accum.tags.push(...currentValue.tags)
                    }

                    if(CATEGORY_KEYWORDS[currentValue.category]){
                        accum.categories.push(currentValue.category)
                    } else {
                        for (const cat in CATEGORY_KEYWORDS) {
                            if(CATEGORY_KEYWORDS[cat].includes(currentValue.category)){
                                accum.categories.push(cat, currentValue.category)
                                break
                            }
                        }
                    }

                    accum.backers.push(currentValue.backers)
                }

                return accum
            }, {
                tags: [],
                categories: [],
                backers: []
            })

        

        const average = searchParams.backers.length > 1 ?
            searchParams.backers.reduce((accum, el) => Number(el) + accum, 0) / searchParams.backers.length : 
            Number(searchParams.backers[0])

        const backersRange = [average - average/2, average + average/2]

        const tags = [...new Set(searchParams.tags)]
        const categories = [...new Set(searchParams.categories)]

        getRecommendations({categories, tags, backers: backersRange, userId: state.value.user.userId}).then(res => {
            campaigns.value = res.map(item => item._source);
        })
    })

    

    return {
        campaigns
    }
}

export default useRecommendations